<template>
  <div class="mb-3">
    <ProjectHeader></ProjectHeader>
    <div class="container pt-3" style="max-width: 1600px;">
      <transition name="fade-alert" mode="out-in">
      <template v-if="error">
        <b-alert
          variant="danger"
          :show="error !== null"
          dismissible
          @dismissed="RESET_ERROR"
        >
          {{ error }}
        </b-alert>
      </template>
      <template v-else-if="projectVuex && projectVuex.announcement">
        <div class="alert alert-success" role="alert">
          <i class="fa fa-flag mr-2" aria-hidden="true"></i
          >{{ projectVuex.announcement }}
        </div>
      </template>
      </transition>
      <b-card no-body header-tag="nav">
        <template #header>
          <ProjectNav></ProjectNav>
        </template>
        <router-view></router-view>
      </b-card>
    </div>
    <ContactProjectManager></ContactProjectManager>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import ProjectHeader from "./header/index.vue";
import ProjectNav from "./nav.vue";
import ContactProjectManager from "../ProjectContactManager.vue";

export default {
  components: {
    ProjectHeader,
    ProjectNav,
    ContactProjectManager,
  },
  provide() {
    return {
      parentValidator: this.$validator,
    };
  },
  created() {
    // Prevent project re-fetch on tab switch
    if (
      !this.projectVuex ||
      this.projectVuex.urlField !== this.$route.params.id
    ) {
      this.getProject(this.$route.params.id);
    }
  },
  computed: {
    ...mapGetters({
      projectVuex: "project/get/project",
      error: "project/get/error",
    }),
  },
  methods: {
    ...mapActions({
      getProject: "project/get/get",
    }),
    ...mapMutations({
      RESET_ERROR: "project/get/RESET_ERROR",
    }),
  },
};
</script>
<style lang="scss" scoped>
.fade-alert-enter-active,
.fade-alert-leave-active {
  transition: opacity 0.5s;
}
.fade-alert-enter,
.fade-alert-leave-to {
  opacity: 0;
}
</style>
